import React, {useEffect, useState} from "react"
import {useHelp, useHelpCta, useMessage,useModal, useProgress, useRoomParameters, useRoomSetup, useSolution, useSolutionRepository, useLocal} from "../AppContext"
import {apiDataToRoomSetup} from "../Hooks/RoomSetup"
import {resetCamera} from "../Helper/CanvasHelper"
import {dispatchSolutionLoadedEvent} from "../Hooks/SolutionRepository"
import {iconArrowEnter, iconArrowToRight, iconArrowToLeft,iconLoad} from "../Helper/Icons"
import {ButtonShy} from "../Components/Button"
import style from "./RoomType.css"


export const RoomType = () => {
    const progress = useProgress()
    const local = useLocal()
    const roomSetup = useRoomSetup()
    const solution = useSolution()
    const helpCta = useHelpCta()
    const roomParameters = useRoomParameters()
    const help = useHelp()
    const roomTypes = roomParameters.getRoomTypes()
    const [room, setFocus] = useState(getRoomByCode(roomTypes, roomSetup.getType()))
    const [isHover, setHover] = useState(false)

    const roomItem = (offset: number) => {
        const count = roomTypes.length
        const roomIndex = getRoomIndexByCode(roomTypes, room.code)
        let itemIndex = roomIndex

        if (offset > 0) {
            offset = offset % count
            itemIndex = (roomIndex + offset < count)
                ? roomIndex + offset
                : roomIndex + offset - count
        } else if (offset < 0) {
            offset = Math.abs(offset) % count
            itemIndex = (roomIndex - offset >= 0)
                ? roomIndex - offset
                : count - (offset - roomIndex)
        }

        const listRoom = roomTypes[itemIndex]

        return <div className={style.item} onClick={() => setFocus(listRoom)}>
            <div className={style.image} style={{backgroundImage: roomImageUrl(listRoom)}}/>
            <div className={style.title}>{local.getLabel(listRoom.name)}</div>
        </div>
    }

    const previewRoom = () => {
        const roomIndex = getRoomIndexByCode(roomTypes, room.code)
        const prevIndex = (roomIndex - 1 < 0) ? (roomTypes.length - 1) : roomIndex - 1
        setFocus(roomTypes[prevIndex])
    }

    const nextRoom = () => {
        const roomIndex = getRoomIndexByCode(roomTypes, room.code)
        const prevIndex = (roomIndex + 1 >= roomTypes.length) ? 0 : roomIndex + 1
        setFocus(roomTypes[prevIndex])
    }

    const selectRoom = () => {
        roomSetup.setType(room.code)
        roomSetup.setDimensions(roomParameters.getDimensions(roomSetup.getShape(), room.code))
        helpCta.reset()
        progress.next()
    }
    
    const SavedRooms  = () => {
      const solutionRepository = useSolutionRepository()
      if (solutionRepository.count() == 0)
        return null
      
      return <ButtonShy onClick={click}>{iconLoad}{local.__("gespeicherte Räume")}</ButtonShy>
    }
    
    const hoverEnter = () => setHover(true)
    const hoverLeave = () => setHover(false)
    const hoverClass = () => isHover ? style.hover : null
    const modal = useModal()
    const solutionRepository = useSolutionRepository()
    const click = () => {
          modal.openSolutionLoad()
        }

    useEffect(() => {
        resetCamera()
        help.setContext('raumtyp')
        roomSetup.reset()
        solution.reset()
    }, [])

    return <div className={style.layout}>
        <div className={style.body}>
            <div className={style.prompt}>{local.__("Wo wollen Sie Ihre Akkustik verbessern?")}</div>
            <div className={style.claim}>{local.__("Wir haben für jeden Raum individuelle Lösungen.")}</div>
            <div className={style.control}>
                <div className={style.banner} style={{backgroundImage: roomImageUrl(room)}}>
                    <div className={style.gradientLeft}/>
                    <div className={style.gradientRight}/>
                    <div className={style.label}>{local.getLabel(room.name)}</div>
                </div>
                <div className={`${style.previewList} ${hoverClass()}`} onMouseEnter={hoverEnter} onMouseLeave={hoverLeave}>
                    {roomItem(-1)}
                </div>
                <div className={`${style.nextList} ${hoverClass()}`} onMouseEnter={hoverEnter} onMouseLeave={hoverLeave}>
                    <div className={style.group}>
                        {roomItem(1)}
                        {roomItem(2)}
                        {roomItem(3)}
                        {roomItem(4)}
                        {roomItem(5)}
                        {roomItem(6)}
                        {roomItem(7)}
                        {roomItem(8)}
                    </div>
                    <div className={style.gradient}/>
                </div>
                <div className={`${style.focus} ${hoverClass()}`}>
                    <div onMouseEnter={hoverEnter} onMouseLeave={hoverLeave}>
                        <div className={style.image} style={{backgroundImage: roomImageUrl(room)}}/>
                        <div className={style.title}>{local.getLabel(room.name)}</div>
                        <div className={style.preview} onClick={previewRoom}>
                            {iconArrowToLeft}
                        </div>
                        <div className={style.next} onClick={nextRoom}>
                            {iconArrowToRight}
                        </div>
                    </div>
                    <div className={style.button} onClick={selectRoom}>
                        {iconArrowEnter}
                        <span>{local.__("Diesen Raum wählen")}</span>
                    </div>
                    <PreparedRooms room={room}/>
                </div>
                <div className={style.roomcode} >
                        <SavedRooms/>
                        <ButtonShy onClick={click}>{iconLoad}{local.__("Raumcode eingeben")}</ButtonShy>
                </div>
            </div>
        </div>
    </div>
}




const PreparedRooms = ({room}) => {
    return <div className={style.sample}>
        {room.examples.map((example) => {
            return <PreparedRoom key={example.code} example={example}/>
        })}
    </div>
}

const PreparedRoom = ({example}) => {
    const message = useMessage()
    const progress = useProgress()
    const roomParameters = useRoomParameters()
    const roomSetup = useRoomSetup()
    const solutionRepository = useSolutionRepository()
    const solution = useSolution()
    const local = useLocal()

    const onClick = async () => {
        try {

            const loadedRoom = await solutionRepository.load(example.code)
            roomSetup.setRoom(apiDataToRoomSetup(loadedRoom.plannings[0].room, roomParameters.getRoomParameters().interiors))
            solution.setPlannings(loadedRoom.plannings[0].room.id, loadedRoom.plannings)

            setTimeout(() => {
                progress.gotoSolution()
                dispatchSolutionLoadedEvent()
            }, 100)

        } catch (error) {
            message.showError(local.__(error.message))
        }
    }

    return <div key={example.code} onClick={onClick}>
        {local.getLabel(example.name)}
    </div>
}

const getRoomByCode = (roomTypes, code: string): any => {
    return roomTypes.find(room => room.code == code) || roomTypes[0]
}

const getRoomIndexByCode = (roomTypes, code: string): number => {
    return roomTypes.findIndex(room => room.code === code)
}

const roomImageUrl = (room): string => {
    return `url("${room.image}")`
}
